import React, { useState } from "react";
import "./Header.css";
import firebase from "firebase/app";

const Header = props => {
  const [showUserInfo, toggleShowUserInfo] = useState(false);
  const user = firebase.auth().currentUser;
  const email = user ? user.email : "";
  const photoURL = user ? user.photoURL : "images/default-user.png";

  const handleUserAvatarClick = e => {
    toggleShowUserInfo(!showUserInfo);
  };
  return (
    <header>
      <div className="header--left">
        <img
          src="images/fit-logo.png"
          alt="fit logo"
          className="header--fit-logo"
        />
        <div className="header--title">
          FIT <span>Website Health & Performance</span>
        </div>
      </div>

      <div className="header--right">
        {props.isSignedIn && (
          <div className="header--avatar">
            <img src={photoURL} alt="user" onClick={handleUserAvatarClick} />
          </div>
        )}
        {showUserInfo && (
          <div className="header--user-info">
            <div className="header--user-info-triangle"></div>
            <span>Email:</span> {email}
          </div>
        )}
        <div>
          {props.isSignedIn && (
            <button
              className="app__primary-button logout"
              onClick={props.signOut}
            >
              Log Out
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
